import {MethodType, ParamsFetchType, GenerateUrlApiType, ResponseType} from 'src_common/browser/apiUtils';

import { GenerateUrlApiParamsType } from 'src_common/server/webDriver/sdkApiWebUtils';
import { openapi_website_cms_deleteCasinoMobileVersion, decodeResponse200, Response200Type } from 'src/api_openapi/generated/openapi_website_cms_deleteCasinoMobileVersion';

export type CasinoMobileVersionModelType = Response200Type;

const decode = (status: number, data: ResponseType): CasinoMobileVersionModelType => {
    if (status === 200 && data.type === 'json') {
        return decodeResponse200(data.json);
    }

    throw new Error(`unhandled response ${status} - ${data.type}`);
};

export interface CasinoMobileVersionTypeSubmitType {
    app_version: string
}

export const deleteCasinoMobileVersion = {
    browser: {
        params: (params: CasinoMobileVersionTypeSubmitType): ParamsFetchType<CasinoMobileVersionTypeSubmitType> => {
            return {
                type: MethodType.POST,
                url: '/api-web/delete-casino-mobile-version',
                body: params
            };
        },
        decode: decode
    },
    express: {
        method: MethodType.POST,
        urlBrowser: '/api-web/delete-casino-mobile-version',
    },
    generateUrlApi: async (params: GenerateUrlApiParamsType<CasinoMobileVersionTypeSubmitType>): Promise<GenerateUrlApiType> => {

        if (params.userSessionId === null) {
            return {
                passToBackend: false,
                status: 403,
                responseBody: {
                    errorMessage: 'User id invalid',
                }
            };
        }

        const response = await openapi_website_cms_deleteCasinoMobileVersion(params.API_URL, params.API_TIMEOUT, params.jwtToken, {
            universe: params.API_UNIVERSE,
            body: params.req.body
        });

        return {
            passToBackend: false,
            status: response.status,
            responseBody: response.body
        };
    }
};
